// extracted by mini-css-extract-plugin
export default {"textarea":"AddNoteModal_textarea__MJ2xV","overlay":"AddNoteModal_overlay__cV5n0"};